/* Custom Hero Banner designed by That! Haus Agency Ltd, More info about our company at www.thathaus.co.uk */

class CustomBannerSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.custom-banner-slideshow__slider');
    this.slides = Array.from(this.slider.children);
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed, 10) * 1000;
    this.currentIndex = 0;

    this.loadingBar = this.querySelector('.custom-banner-slideshow__loading-bar');

    if (!this.slides.length) return;

    this.init();
  }

  init() {
    if (this.autoplay && this.slides.length > 1) {
      this.startAutoplay();
    }
    if (this.loadingBar) {
      this.resetAndStartLoadingBar();
    }
  }

  startAutoplay() {
    this.autoplayInterval = setInterval(() => {
      this.nextSlide();
    }, this.speed);
  }

  resetAndStartLoadingBar() {
    this.loadingBar.style.transition = 'none';
    this.loadingBar.style.width = '0%';
    void this.loadingBar.offsetWidth;
    this.loadingBar.style.transition = `width ${this.speed / 1000}s linear`;
    this.loadingBar.style.width = '100%';
  }

  nextSlide() {
    const previousIndex = this.currentIndex;
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;

    this.slider.style.transform = `translateX(-${this.currentIndex * 100}%)`;

    this.slides[previousIndex].classList.remove('is-active');
    this.slides[this.currentIndex].classList.add('is-active');

    if (this.loadingBar) {
      this.resetAndStartLoadingBar();
    }
  }
}

customElements.define('custom-banner-slideshow', CustomBannerSlideshow);